let idCounter = 0;

// Exported from lodash but removed all the usless junk from it
// prefix is types as string no need to check 1000 things.
export const uniqueId = (prefix = "") => {
  const id = ++idCounter;
  return prefix + id;
};
